var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6547 2.33449C18.8413 1.72335 21.639 4.52097 21.0278 7.70757L19.2732 16.8566C18.8918 18.8455 17.3863 20.436 15.4302 20.9414C11.5245 21.9503 7.95512 18.3282 9.0988 14.4391C9.13038 14.3317 9.0306 14.2319 8.9232 14.2635C5.03411 15.4072 1.41207 11.8378 2.42098 7.93218C2.9263 5.97601 4.51685 4.47056 6.50569 4.08914L15.6547 2.33449Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.e9c53cc99d205eabd2772f6900a4127d.svg";
export { ForwardRef as ReactComponent };